import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import React, { useContext, useMemo } from "react";
import {
    dislikeOrCancel,
    likeOrCancel,
    ReplyItemData,
    SpeakerType
} from "service/discuss";
import styles from "./index.module.scss";
import useStorage from "utils/useStorage";
import useRequestFn from "utils/useRequestFn";
import { Button, message } from "antd";
import { errorMessage } from "service/service";
import { DiscussContent } from "../../context";
import className from "classnames";

interface LikeOrNotProps {
    answerData: ReplyItemData;
}

export function LikeOrNot({ answerData }: LikeOrNotProps) {
    const { updateDiscussDetail } = useContext(DiscussContent);
    const [teacherNo] = useStorage("teacherNo");

    const { topicUuid, uuid } = answerData;

    function findInList(list?: { type: string; no: string }[]) {
        if (!list) return false;
        return !!list.find(
            item => item.no === teacherNo && item.type === SpeakerType.Teacher
        );
    }

    // 点过赞
    const liked = useMemo(() => findInList(answerData.likes), [answerData]);

    // 点过踩
    const disLiked = useMemo(
        () => findInList(answerData.dislikes),
        [answerData]
    );

    const [onLike, likeStatus] = useRequestFn(async () => {
        try {
            await likeOrCancel(topicUuid, uuid);
            await updateDiscussDetail();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const [onDisLike, disLikeStatus] = useRequestFn(async () => {
        try {
            await dislikeOrCancel(topicUuid, uuid);
            await updateDiscussDetail();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const isLoading = likeStatus.loading || disLikeStatus.loading;

    return (
        <>
            <Button
                className={className(styles.btnLike, {
                    [styles.btnOn]: liked
                })}
                title="赞同"
                onClick={onLike}
                disabled={disLiked || isLoading}>
                <AiOutlineLike /> {answerData.likeCount || 0}
            </Button>

            <Button
                className={className(styles.btnDisLike, {
                    [styles.btnOn]: disLiked
                })}
                title="反对"
                onClick={onDisLike}
                disabled={liked || isLoading}>
                <AiOutlineDislike /> {answerData.dislikeCount || 0}
            </Button>
        </>
    );
}
